import React from 'react';

const AsyncTvAdsContainer = React.lazy(() => import('./ListContainer'));

export const TvAdsPage = () => {
  return <AsyncTvAdsContainer />;
};
